import { API_BASE_URL } from '../config/apiBase';
import { ensureCsrfToken, isPlausibleCsrfToken, readCsrfCookie } from './csrf';

const API_BASE = API_BASE_URL;

async function publicRequest(path, options = {}) {
  const headers = {
    Accept: 'application/json',
    ...(options.headers || {}),
  };
  if (options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  const method = (options.method || 'GET').toUpperCase();
  if (method !== 'GET' && method !== 'HEAD') {
    let csrf = readCsrfCookie();
    if (!isPlausibleCsrfToken(csrf)) {
      csrf = await ensureCsrfToken();
    }
    headers['X-CSRFToken'] = csrf;
  }
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...options,
    headers,
  });
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (err) {
      data = { error: { message: text } };
    }
  }
  if (!response.ok) {
    const error = new Error(
      (data && data.error && data.error.message) || `Request failed (${response.status})`
    );
    error.status = response.status;
    throw error;
  }
  return data;
}

export function fetchPublicTiers() {
  return publicRequest('/v1/public/tiers/');
}

export function submitDeveloperSignup(payload) {
  return publicRequest('/v1/signup/developer/', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function resendEmailVerification() {
  return publicRequest('/v1/account/email-verification/send/', { method: 'POST' });
}

export function confirmEmailVerification(token) {
  return publicRequest('/v1/account/email-verification/confirm/', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
}
